import { connect } from 'react-redux'
import requestAddUser from '../../sagas/requestAddUser'
import requestMakeUserResponsible from '../../sagas/requestMakeUserResponsible'
import requestRemoveUser from '../../sagas/requestRemoveUser'
import usersSelector from './usersSelector'
import Users from './Users'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  usersSelector,
  {
    requestAddUser,
    requestRemoveUser,
    requestMakeUserResponsible
  }
)(Users))
